import { icon_fold_on } from 'components/base/images';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import cx from 'classnames';
import MuiAccordion from '@material-ui/core/Accordion';
import { AccordionDetails, AccordionSummary } from '@material-ui/core';
import ProjectFileItem from './ProjectFileItem';
import { IConvertFile } from 'lib/types/clinic/fileTypes';
import { useProjectFiles } from 'lib/hooks/project/useProjectFiles';
import { clinicModelTypes } from 'lib/mapper';
import CustomText from 'components/common/text/CustomText';

interface ProjectFileListProps {
  titleIcon?: string;
  title?: string;
  myFiles: IConvertFile[];
}

function FileListFolder({ titleIcon = '', title = '', myFiles }: ProjectFileListProps) {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState<boolean>(true);
  const { handleChangeCheckbox, handleClickView } = useProjectFiles();

  return (
    <StyledFileListFolder data-component-name="FileListFolder">
      <MuiAccordion
        className="fileListFolder__box"
        expanded={isExpanded}
        onChange={() => {
          setIsExpanded(!isExpanded);
        }}
      >
        <AccordionSummary className={cx('fileListFolder__contents summary', {})}>
          <div className="summary_title">
            {!!titleIcon && (
              <div className="summary_title_icon">
                <img src={titleIcon} />
              </div>
            )}
            <CustomText fontSize={16} fontColor="#222" fontWeight={400}>
              {title}
            </CustomText>
          </div>
          <div className={cx('summary_icon', { expanded: !!isExpanded })}>
            <img src={icon_fold_on} />
          </div>
        </AccordionSummary>
        <AccordionDetails className={cx('fileListFolder__contents detail', {})}>
          <div className="detail_container">
            {myFiles.length > 0 &&
              myFiles.map((file: IConvertFile, index: number) => {
                const isSlider = clinicModelTypes.includes(file.fileExtension);
                return (
                  <ProjectFileItem
                    file={file}
                    key={index}
                    useCheckbox
                    useSlider={isSlider}
                    useViewer
                    onChangeCheckbox={handleChangeCheckbox}
                    onClickView={handleClickView}
                  />
                );
              })}
          </div>
        </AccordionDetails>
      </MuiAccordion>
    </StyledFileListFolder>
  );
}

export default React.memo(FileListFolder);

const StyledFileListFolder = styled.div`
  width: 100%;
  .fileListFolder__box {
    border-radius: 10px !important;
    overflow: hidden;
    border: 1px solid #e1e1e7;
    background-color: #f9f9fb;
    box-shadow: none;
    .MuiAccordionSummary-root {
      padding: 0 20px;
    }
    .fileListFolder__contents {
      &.summary {
        min-height: 40px;
        height: 40px;
        overflow: hidden;
        /* padding: 13px 20px; */
        .summary_title {
          display: flex;
          align-items: center;
          column-gap: 12px;
          .summary_title_icon {
            width: 18px;
            height: 18px;
          }
        }
        .summary_icon {
          display: flex;
          justify-content: space-between;
          align-items: center;
          &.expanded {
            rotate: 180deg;
          }
        }
        &.Mui-expanded {
          /* border-bottom: 1px solid #e1e1e7; */
        }
      }
    }

    .fileListFolder__contents {
      &.detail {
        width: calc(100% - 8px);
        margin: 0 auto 4px auto;
        background-color: #fff;
        padding: 4px;
        border-radius: 5px !important;
        border: 1px solid #e1e1e7;
        .detail_container {
          width: 100%;
        }
      }
    }
  }
  .MuiAccordionSummary-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.Mui-expanded {
      margin: 0;
      /* border-bottom: 1px solid #e1e1e7; */
    }
  }
`;
